import { Button, HStack, Heading, Text, VStack } from "@chakra-ui/react"
import Pathicon from "@pathwright/features/src/modules/pathicon/Pathicon"
import { usePdfInfoResult } from "@pathwright/ux/src/components/filestack/api"
import Link from "@pathwright/ux/src/components/link/Link"
import { useMeasure } from "react-use"
import useActiveCertificate from "../hooks/useActiveCertificate"
import CertificateTemplate from "../template/CertificateTemplate"
import InvalidCertificateTemplateError from "../template/InvalidCertificateTemplateError"

const CertificateUpdatePrompt = () => {
  const certificate = useActiveCertificate()
  const { template } = certificate
  const { data: pdfInfo, error: pdfInfoError } = usePdfInfoResult(template)
  const templateDimensions = pdfInfo?.pagesize
    ? {
        height: pdfInfo.pagesize.height ?? 0,
        width: pdfInfo.pagesize.width ?? 0
      }
    : null
  const [nodeRef, size] = useMeasure()

  return (
    <VStack gap={4} padding={4} pt={0} minW="100%" textAlign="center">
      <Pathicon icon="certificate" style={{ fontSize: "24px" }} />
      <Heading as="h3" size="xl">
        Configure Completion Certificates
      </Heading>
      <Text textAlign="center">
        Update your Completion Certificate Template and select the Paths where
        it’s used.{" "}
        <Link
          textDecoration="underline"
          textUnderlineOffset={2}
          href="http://help.pathwright.com/en/articles/9211185-provide-a-certificate-of-completion"
        >
          Learn more about certificates.
        </Link>
      </Text>
      <VStack maxW="250px" ref={nodeRef} gap={0}>
        {pdfInfoError ? (
          <InvalidCertificateTemplateError
            primaryAction={{
              to: "/certificate/",
              label: "Update Certificate Template"
            }}
          />
        ) : (
          <CertificateTemplate
            template={template}
            templateDimensions={templateDimensions}
            scaleSize={size}
          />
        )}
        <Button
          asChild
          colorPalette="brand"
          variant="solid"
          transform={pdfInfoError ? undefined : "translateY(-50%)"}
          mb={pdfInfoError ? undefined : "calc(var(--chakra-spacing-4)* -2)"}
        >
          <Link to="/certificate/" variant="plain" textDecor="none">
            <HStack>
              <Pathicon icon="edit" />
              <span>Update Certificate Template</span>
            </HStack>
          </Link>
        </Button>
      </VStack>
    </VStack>
  )
}

export default CertificateUpdatePrompt
